import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Plyr from 'plyr';
require('../../node_modules/plyr/dist/plyr.css');

document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementById('presenterVideo');

    const init = function() {       
              
        const player = new Plyr(el, {
            autoplay: false,
            muted: true, 
            volume: 0,
            controls: false
        });      
        
        const enterFunc = function() {
            player.muted = true;
            player.play();
        }       
        
        ScrollTrigger.create({
            start: 'top 60%',
            trigger: '#presenterVideo',
            onEnter: enterFunc,
            once: true
        });
    };
    
    el ? init() : false; 

}, false)
